import { ActionContext } from 'vuex'
import apiAdminMissionPlanTemplate from '@/api/admin/missionPlanTemplate'
import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'
import { IMissionPlanTemplateState } from './state'
import { ApiResultCode } from '@/models/response/AlrBase'
import { AloDbMissionPlanTemplate, IAloDbMissionPlanTemplateConstParam } from '@/models/alodb/AloDbMissionPlanTemplate'
import { AloError } from '@/models/alo/AloError'
import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { router } from '@/mainjs.js'
import Vue from 'vue'
import {i18n} from '@/locale/vueI18n'

export class MissionPlanTemplateAction {
  public [types.MISSIONPLANTEMPLATE_REQUEST](context: ActionContext<IMissionPlanTemplateState, IRootState>) {
    return new Promise((resolve, reject) => {
      context.commit(types.MISSIONPLANTEMPLATE_REQUEST)
      apiAdminMissionPlanTemplate
        .getMissionPlanTemplates()
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const missionPlanTemplateArray = resp.data.data as AloBaseArray<AloDbMissionPlanTemplate>
            context.commit(types.MISSIONPLANTEMPLATE_SUCCESS, missionPlanTemplateArray.items)
            resolve(missionPlanTemplateArray.items)
          } else {
            context.commit(types.MISSIONPLANTEMPLATE_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.MISSIONPLANTEMPLATE_ERROR)
          reject()
        })
    })
  }

  public [types.MISSIONPLANTEMPLATE_ENSURE_LIST](context: ActionContext<IMissionPlanTemplateState, IRootState>) {
    if (context.state.missionPlanTemplates.length == 0) {
      return context.dispatch(types.MISSIONPLANTEMPLATE_REQUEST)
    } else {
      return new Promise((resolve, reject) => {
        resolve(context.state.missionPlanTemplates)
      })
    }
  }

  public [types.MISSIONPLANTEMPLATE_SELECT_DETAIL](context: ActionContext<IMissionPlanTemplateState, IRootState>, itemId: number) {
    return new Promise((resolve, reject) => {
      const missionPlanTemplate = context.getters.missionPlanTemplatesById[itemId] as AloDbMissionPlanTemplate      
      if (missionPlanTemplate) {
        if (missionPlanTemplate.detailLoaded) {
          context.commit(types.MISSIONPLANTEMPLATE_SELECT_DETAIL, missionPlanTemplate)
          resolve(missionPlanTemplate)
        } else {
          //s'assure que le contexte sera existant
          context.dispatch(types.UI_ENSURE_MISSIONPLAN_STATE,  {id:itemId,typeUiid:"template"}).then(rep => {
            context.dispatch(types.MISSIONPLANTEMPLATE_SELECT_DETAIL_REQUEST, itemId).then(ens => {
              context.commit(types.MISSIONPLANTEMPLATE_SELECT_DETAIL, ens)
              resolve(ens)
            })
          })
        }
      } else {
        const newMissionPlanTemplate = new AloDbMissionPlanTemplate({
          ENS_ID : context.rootState.auth.userProfile.ensId
        }as IAloDbMissionPlanTemplateConstParam)
        context.commit(types.MISSIONPLANTEMPLATE_SELECT_DETAIL, newMissionPlanTemplate)
        resolve(newMissionPlanTemplate)
      }
    })
  }

  public [types.MISSIONPLANTEMPLATE_SELECT_DETAIL_REQUEST](context: ActionContext<IMissionPlanTemplateState, IRootState>, itemId: number) {
    return new Promise((resolve, reject) => {
      context.commit(types.MISSIONPLANTEMPLATE_SELECT_DETAIL_REQUEST, itemId)
      apiAdminMissionPlanTemplate
        .getMissionPlanTemplate(itemId)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const missionPlanTemplate = resp.data.data as AloDbMissionPlanTemplate
            context.commit(types.MISSIONPLANTEMPLATE_SELECT_DETAIL_SUCCESS, missionPlanTemplate)
            context.commit(types.MISSIONPLANTEMPLATE_SELECT_DETAIL, missionPlanTemplate)
            resolve(missionPlanTemplate)
          } else {
            context.commit(types.MISSIONPLANTEMPLATE_SELECT_DETAIL_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(() => {
          context.commit(types.MISSIONPLANTEMPLATE_SELECT_DETAIL_ERROR)
          reject()
        })
    })
  }

  public [types.MISSIONPLANTEMPLATE_SAVE_REQUEST](context: ActionContext<IMissionPlanTemplateState, IRootState>,template:AloDbMissionPlanTemplate|null) {
    return new Promise((resolve, reject) => {
      const saveTemplate = template || context.state.modifiedAdmMissionPlanTemplate
      const tryRedirect = template?false:!context.state.modifiedAdmMissionPlanTemplate.id
      context.commit(types.MISSIONPLANTEMPLATE_SAVE_REQUEST, saveTemplate.MPT_LIBELLE)
      apiAdminMissionPlanTemplate
        .saveMissionPlanTemplate(saveTemplate)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {            
            const missionPlanTemplate = resp.data.data as AloDbMissionPlanTemplate
            if(tryRedirect || template){
              context.dispatch(types.UI_ENSURE_MISSIONPLAN_STATE,  {id:missionPlanTemplate.MPT_ID,typeUiid:"template"})
            }
            context.commit(types.MISSIONPLANTEMPLATE_SELECT_DETAIL_SUCCESS, missionPlanTemplate)
            if(!template) { context.commit(types.MISSIONPLANTEMPLATE_SELECT_DETAIL, missionPlanTemplate)}
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.SaveOk',{item:missionPlanTemplate.MPT_LIBELLE}))          
            if (tryRedirect && router.app.$route.name === 'NewMissionPlanTemplate')
              router.push({ name: 'EditMissionPlanTemplate', params: { itemid: missionPlanTemplate.id!.toString() } })
            resolve(missionPlanTemplate)
          } else {
            console.error('ATTENTION une reponse Code 200 contient une erreur')
            context.commit(types.MISSIONPLANTEMPLATE_SAVE_ERROR)
            const error = resp.data.data as AloError
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:error.errorMessage}))
            console.error(error)
            reject(error)
          }
        })
        .catch(error => {
          context.commit(types.MISSIONPLANTEMPLATE_SAVE_ERROR)
          if (error.response) {
            const er = error.response.data.data as AloError
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:er.errorMessage}))
            console.error(er)
            reject(er)
          } else {
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnSave'))
            reject()
          }
        })
    })
  }

  public [types.MISSIONPLANTEMPLATE_UPDATE_MODIFIED_ADM](
    context: ActionContext<IMissionPlanTemplateState, IRootState>,
    newProperties: Object
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.MISSIONPLANTEMPLATE_UPDATE_MODIFIED_ADM, newProperties)
      resolve(context.state.modifiedAdmMissionPlanTemplate)
    })
  }

  public [types.MISSIONPLANTEMPLATE_CANCEL_MODIFIED_ADM](context: ActionContext<IMissionPlanTemplateState, IRootState>) {
    return new Promise((resolve, reject) => {
      context.commit(types.MISSIONPLANTEMPLATE_SELECT_DETAIL, context.state.originalAdmMissionPlanTemplate)
      resolve(context.state.modifiedAdmMissionPlanTemplate)
    })
  }

  public [types.MISSIONPLANTEMPLATE_UPDATE_FILTER_ADM](context: ActionContext<IMissionPlanTemplateState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.MISSIONPLANTEMPLATE_UPDATE_FILTER_ADM,newProperties)
      resolve(context.state.adminFilter)
    })
  }

  public [types.MISSIONPLANTEMPLATE_DELETE_REQUEST](context: ActionContext<IMissionPlanTemplateState, IRootState>) {
    return new Promise<void>((resolve, reject) => {      
      const mptId = context.state.originalAdmMissionPlanTemplate.MPT_ID!
      const mptLibelle = context.state.originalAdmMissionPlanTemplate.MPT_LIBELLE
      context.commit(types.MISSIONPLANTEMPLATE_DELETE_REQUEST, mptLibelle)
      apiAdminMissionPlanTemplate
        .deleteMissionPlanTemplate(mptId)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            context.commit(types.MISSIONPLANTEMPLATE_DELETE_SUCCESS, mptId)
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.DeleteOk',{item:mptLibelle}))   
            if (router.app.$route.name === 'EditMissionPlanTemplate' && context.state.originalAdmMissionPlanTemplate.MPT_ID! == mptId) {
              router.push({ name: 'NewMissionPlanTemplate' })
            }
            resolve()
          } else {
            console.error('ATTENTION une reponse Code 200 contient une erreur')
            context.commit(types.MISSIONPLANTEMPLATE_DELETE_ERROR)
            const error = resp.data.data as AloError
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:error.errorMessage}))
            console.error(error)
            reject(error)
          }
        })
        .catch(error => {
          context.commit(types.MISSIONPLANTEMPLATE_DELETE_ERROR)
          if (error.response) {
            const er = error.response.data.data as AloError
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorSave',{error:er.errorMessage}))
            console.error(er)
            reject(er)
          } else {
            context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnSave'))
            reject()
          }
        })
    })
  }
}

export default util.classToObject(MissionPlanTemplateAction)
